export const installTypeRoute = {
  loadChildren: () =>
    import('./install-type.module').then(m => m.InstallTypePageModule)
};
